// 15-05-2025
import { getStatus } from "../statusAPI";

  /**
   * Makes a call to get the status
   * @param {string} id - to get the status valid "id" or by default "all" provides all the status
   * @param {string} type - to get the status of the type or  "*" for all the status
   * @returns - returns status data
   */
  const handleGetStatus = async (id) => {
    try {
      const response = await getStatus(id,"Faulted");
      const { message, data } = response;
      return data;
    } catch (err) {
      if (err.isErr) {
        console.log("Error getting the Status", err.msg);
        console.log("Problem: ", err.problem);
      } else {
        console.log("Unexpected Error: ", err);
      }
      return err;
    }
  };

//  to fetch all the transaction based on charger Ids under the Faults
export const loadFaults = async (data) => {
  let faults = [];
  await Promise.all(
    data.map(async (charger) => {
      try {
        const res = await handleGetStatus(charger);
        faults.push(...res);
      } catch (err) {
        console.log("Error loading faults for ID", charger, err);
      }
    })
  );
  
  //Sort by StartTime
   faults?.length > 0 &&  faults.sort((a, b) => {
      if (a.timeStamp && b.timeStamp) {
        return -a.timeStamp.localeCompare(b.timeStamp);
      }
      return 0; // or handle as necessary if startTime is missing
    });
  return faults;
};
